/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2020, Bulb Inc. For more information, please email contact@hellobulb.com.
 *          _
 *  _            | | _
 * | |         _ | || |
 * | |__   _  | || || |__
 * | '_ \ | | | || || '_ \
 * | (_) || |_| || || (_) |
 *  \___/  \___/ |_| \___/
 *
*/

import { Inject, Injectable } from '@angular/core';

/**
 * Angular service that injects our AngularJS translation service so that we can dynamically translate values in our
 * Angular framework.
 */
@Injectable()
export class TranslationService {
  /**
   * Default constructor that injects our AngularJS translation service.
   *
   * @param $translate AngularJS $translate service.
   */
  constructor(@Inject('$translate') private $translate) {}

  /**
   * Translate method that translates a keyword.
   *
   * @param keyWord The keyword that needs to be translated.
   * @returns string The translated keyword as a string.
   */
  translateInstant(keyWord : string) : string {
    // We are leveraging the AngularJS translate service instant method.
    return this.$translate.instant(keyWord);
  }

  translateCustomKeys(keyWord : string, placeholder : object) : Promise< any > {
    return this.$translate(keyWord, placeholder);
  }

  /**
   * Translate method that translates keyword.
   *
   * @param keyWord The keyword that needs to be translated.
   * @returns A promise resolving to the translated keyword.
   */
  translate(keyWord : string) : Promise< any > {
    return this.$translate(keyWord);
  }

  /**
   * Translate method that translates a list of keyword.
   *
   * @param keyWords The keywords that needs to be translated.
   * @returns string The translated keywords as a Array of string.
   */
  translateArrayInstant(keyWords : Array<string>) : Array<string> {
    const translatedKeyWords = [];

    for (let i = 0; i < keyWords.length; i++) {
      translatedKeyWords.push(this.$translate.instant(keyWords[i]));
    }
    return translatedKeyWords;
  }

  /**
   * Get translations list against user selected language.
   * @param langKey
   */
  getTranslations(langKey: string) {
    return this.$translate.getTranslationTable(langKey);
  }
}
